import * as z from "zod";

export const getMetaAdsOAuthURL = {
  name: "getMetaAdsOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
